export enum JourneyStatus {
    Published = 'Published',
    Unpublished = 'Unpublished',
    SoftDelete = 'SoftDelete'
}
